import { array, boolean, number, object, string } from "yup";

export const empaqueValidation = object({
  id_campo: number().moreThan(0).required(),
  id_diaria: number().when("bicolor", (bicolor, schema) =>
    bicolor ? schema : schema.moreThan(0).required()
  ),
  variedad: string().required(),
  variedad_bicolor: array()
    .of(
      object({
        id_diaria: number().moreThan(0).required(),
        id_variedad: number().moreThan(0).required(),
        variedad: string().required(),
      })
    )
    .when("bicolor", (bicolor, schema) =>
      bicolor ? schema.min(1).required() : schema
    ),
  resto: boolean().required(),
  calibre: string().required(),
  total: number()
    .moreThan(0, "Favor de ingresar un numero mayor a 0")
    .required("Campo obligatorio"),
  id_tipo_etiqueta: number().moreThan(0).required(),
  id_peso_envase: number().moreThan(0).required(),
  id_tipo_caja: number().moreThan(0).required(),
  id_etiqueta: number().moreThan(0).required(),
  id_bultos_por_palet: number(),
  bultos_por_palet: number()
    .moreThan(0, "Favor de ingresar un numero mayor a 0")
    .required("Campo obligatorio"),
  cantidad_palet: number()
    .moreThan(0, "Favor de ingresar un numero mayor a 0")
    .required("Campo obligatorio"),
  id_yeguere: number().moreThan(0).required(),
  id_destino: number().moreThan(0).required(),
  tipo_pedido: string().required(),
  id_destino_inmediato: number().moreThan(0).required(),
  id_tarima: number().moreThan(0).required(),
  fumigar: boolean().required(),
  prioridad: boolean().required(),
  observaciones: string().nullable().notRequired(),
  fecha: string().required(),
  limite: number().when("resto", (resto, schema) =>
    resto
      ? schema
          .moreThan(0, "Favor de ingresar un numero mayor a 0")
          .required("Campo obligatorio")
      : schema
  ),
  id_variedad: number().when("bicolor", (bicolor, schema) =>
    bicolor ? schema : schema.moreThan(0).required()
  ),
  bicolor: boolean().required(),
});
